import getRegionalOptions from '../data/store/store';
import setHasUserChangedLanguage from '../data/mutators/setHasUserChangedLanguage';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var localeHotReload = function (languageHasChanged) {
    var optionState = getRegionalOptions();
    if (languageHasChanged &&
        (!isControlFeatureEnabled('fwk-localeHotReload') || optionState.shouldRenameDefaultFolders)) {
        setHasUserChangedLanguage(true);
    }
};
export default localeHotReload;
//# sourceMappingURL=localeHotReload.js.map